module.exports = __webpack_public_path__ + "img/cmsriver-logo.75dd4a49.png";